module.exports = __webpack_public_path__ + "static/media/sourcetree.ebfa82f4.svg";